/**
 * PublicShell — layout for every anonymous page under /club.
 *
 * Mirrors AppShell's header (white bar, logo, gold UCC wordmark, tagline) so
 * the public site reads as the same product. What it deliberately drops:
 * the hamburger menu, the Player/Admin toggle and the bottom nav — all member
 * navigation. Keeping this as a separate file from AppShell means a public
 * page can never accidentally render member chrome.
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import AuctionBanner from './AuctionBanner';
const NAVY = '#1E3A6E';
const GOLD = '#F5C518';
const C = { page: '#f1f5f9' };
const WRAP = { maxWidth: 720, margin: '0 auto', width: '100%' };

const TABS = [
  { path: '/club', label: 'Home' },
  { path: '/club/members', label: 'Members' },
  { path: '/club/rankings', label: 'Rankings' },
  { path: '/club/scorecards', label: 'Scorecards' },
  { path: '/club/records', label: 'Records' },
  { path: '/club/honours', label: 'Honours' },
  { path: '/club/videos', label: 'Videos' },
];

export default function PublicShell({ children }) {
  const { pathname } = useLocation();

  return (
    <div style={{ minHeight: '100vh', background: C.page }}>
      <style>{`
        .ucc-pub-tabs::-webkit-scrollbar { display: none; }
        .ucc-pub-tabs { scrollbar-width: none; -ms-overflow-style: none; }
      `}</style>

      <header style={{ background: 'white', borderBottom: '1px solid #e5e7eb',
        position: 'sticky', top: 0, zIndex: 50 }}>
        <div style={{ ...WRAP, padding: '9px 14px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>

          <Link to="/club" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
            <img src="/logo192.png" alt=""
              style={{ width: 38, height: 38, objectFit: 'contain' }}
              onError={e => { e.target.style.display = 'none'; }} />
            <div>
              <div style={{ fontFamily: 'Rajdhani,sans-serif', fontWeight: 800, fontSize: '1.25rem',
                color: GOLD, letterSpacing: '0.18em', lineHeight: 1 }}>UCC</div>
              <div style={{ fontSize: '0.5rem', color: '#9ca3af', letterSpacing: '0.1em', marginTop: 3 }}>
                YOU PLAY CRICKET · WE LIVE FOR IT
              </div>
            </div>
          </Link>

          <Link to="/login" style={{
            background: NAVY, color: 'white', textDecoration: 'none',
            fontFamily: 'Rajdhani,sans-serif', fontWeight: 800, fontSize: '0.8rem',
            letterSpacing: '0.05em', padding: '8px 16px', borderRadius: 20, whiteSpace: 'nowrap',
          }}>MEMBER SIGN IN</Link>
        </div>

        <div style={{ position: 'relative' }}>
        <div className="ucc-pub-tabs" style={{
          ...WRAP, padding: '0 28px 0 16px', display: 'flex', gap: 18,
          overflowX: 'auto', WebkitOverflowScrolling: 'touch',
        }}>
          {TABS.map(t => {
            const active = t.path === '/club' ? pathname === '/club' : pathname.startsWith(t.path);
            return (
              <Link key={t.path} to={t.path} style={{
                textDecoration: 'none', fontSize: '0.8rem',
                fontFamily: 'Rajdhani,sans-serif', fontWeight: 700, letterSpacing: '0.03em',
                color: active ? NAVY : '#9ca3af',
                borderBottom: active ? `3px solid ${GOLD}` : '3px solid transparent',
                padding: '4px 0 8px', whiteSpace: 'nowrap', flexShrink: 0,
              }}>{t.label}</Link>
            );
          })}
        </div>
        {/* Right-edge fade — tells the eye the strip continues. */}
        <div style={{
          position: 'absolute', right: 0, top: 0, bottom: 0, width: 26,
          background: 'linear-gradient(to right, rgba(255,255,255,0), #fff)',
          pointerEvents: 'none',
        }} />
        </div>
      </header>

      <main style={{ ...WRAP, padding: '16px 16px 24px' }}><AuctionBanner />{children}</main>

      <footer style={{ background: 'white', borderTop: '1px solid #e5e7eb', padding: '16px' }}>
        <div style={{ ...WRAP, textAlign: 'center', fontSize: '0.72rem', color: '#9ca3af' }}>
          United Cricket Club · Ludhiana
        </div>
      </footer>
    </div>
  );
}
